<template lang="pug">
  content-page
    h1(v-html="contentpage.name")
    ws-content(:value="contentpage.content")
      weathermap(:type="type" region="europe" :rundate="rundate")
      div(v-if="type == 'snowforecast'")
        h2.m-b-2 {{ $t('page.weather.europe.snowforecast:forecast_6days')}}
        forecast-list-table(:forecast="forecast")
    div(slot="nav")
      navigation
</template>

<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';
import Content from '@dengl/common/components/content.vue';
import Navigation from '@/components/navigation';
import Weathermap from '@/components/weather/weathermap/interactive';
import ForecastListTable from '@/components/weather/forecast-list-table';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const contentpageQuery = gql`
	query getForecastListData($path: String) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

const forecastQuery = gql`
	query getForecastListData($sort: forecastSortInput) {
		forecast: forecastTopUpcoming6Days(sort: $sort) {
			maxSnowMountain
			nodes {
				snowTotal
				ranking
				snowValleyUpcoming6Days
				destination {
					name
					slug
					country {
						id
						name
						countryCode
					}
					... on Area {
						snowheights {
							nodes {
								elevatorsTotal
								elevatorsOpen
							}
						}
					}
				}
			}
		}
	}
`;

export default {
	name: 'WeatherEuropeType',
	components: {
		Navigation,
		Weathermap,
		ForecastListTable
	},
	layout: 'default',
	nuxtI18n: {
		paths: {
			'nl-NL': '/weersneeuw/europe/:type',
			'nl-BE': '/weersneeuw/europe/:type',
			'de-DE': '/wetter-schnee/europa/:type'
		}
	},
	async asyncData({ params, app, route }) {
		app.ads({ navigation: { visible: true } });
		const type = app.$normalizeSlug(params.type);

		const contentpage = await app.$graphClient
			.query({
				query: contentpageQuery,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				app.meta(data.contentpage.meta);
				app.breadcrumbs({
					[app.i18n.t('page.weather:breadcrumb')]: { name: 'weather' },
					[app.i18n.t(`page.weather.europe.${type}:breadcrumb`)]: {
						name: 'weather-europe-type',
						params: { type: params.type }
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'weather-europe-type-01', error);
			});

		let forecast = null;

		if (type === 'snowforecast') {
			forecast = await app.$graphClient
				.query({
					query: forecastQuery,
					variables: {
						sort: {
							field: 'SNOWTOTAL',
							ascending: false
						}
					},
					errorPolicy: 'all'
				})
				.then(({ data, errors }) => {
					if (errors) {
						throw errors[0];
					}

					return data;
				})
				.catch(error => {
					return app.httpError(500, null, 'weather-europe-type-01', error);
				});
		}

		return { ...contentpage, ...forecast, type };
	},
	computed: {
		...mapState(['rundate'])
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>

<style></style>
